package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PreMadeCharacterToCreate(
    @SerialName("table_id")
    val tableId: String,

    @SerialName("name")
    val name: String,

    @SerialName("story")
    val story: String,

    @SerialName("sheet")
    val sheet: CharacterSheet = CharacterSheet(),

    @SerialName("inventory")
    val inventory: List<PreMadeInventoryItem> = emptyList()
)
